"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8885],{

/***/ 47755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ GridImageWithParagraph; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./segments/desktop/core-components/grid-image/grid-image.js + 1 modules
var grid_image = __webpack_require__(94351);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title_title = __webpack_require__(91265);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/paragraph.js + 1 modules
var paragraph = __webpack_require__(75073);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/secondary-button/secondary-button.js + 1 modules
var secondary_button = __webpack_require__(95736);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./segments/desktop/constants.js
var constants = __webpack_require__(73759);
;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-image-with-paragraph/grid-image-with-paragraph.scss.js



var StyledGridImageWithParagraph = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "e13wd3ew0"
})("text-decoration:none;color:", colors/* default.black */.Z.black, ";height:100%;&.without-link{.grid-image-with-paragraph{cursor:initial;&:hover{transform:none;}}}.grid-image-with-paragraph{display:flex;flex-direction:column;height:100%;width:100%;cursor:pointer;padding:16px;background-color:", colors/* default.white */.Z.white, ";transition:transform 300ms ease;", (0,constants.getComponentShadow)(), "    &:hover{", (0,constants.getComponentShadowWithHoverEffect)(), "}&:hover{transform:scale(1.05);}.grid-paragraph-wrapper{height:100%;margin-top:16px;display:flex;flex-direction:column;.title-wrapper{width:100%;margin-bottom:16px;height:64px;overflow:hidden;}.paragraph-body-wrapper{flex-grow:1;}.button-wrapper{margin-top:32px;}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/grid-image/default-props.js
var default_props = __webpack_require__(80651);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/default-props.js
var title_default_props = __webpack_require__(51261);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/default-props.js
var paragraph_default_props = __webpack_require__(14066);
;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-image-with-paragraph/default-props.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var grid_image_with_paragraph_default_props = (_object_spread_props(_object_spread({}, _object_spread_props(_object_spread({}, default_props/* default */.Z), {
    src: "/static/img/segment-layout-default-images/grid/man-with-blue-shirt.png"
})), {
    fullParagraph: _object_spread({}, title_default_props/* default */.Z, paragraph_default_props/* default */.Z)
}));

;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-image-with-paragraph/grid-image-with-paragraph.js






function grid_image_with_paragraph_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function grid_image_with_paragraph_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            grid_image_with_paragraph_define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}










var GridImageWithParagraph = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(GridImageWithParagraph, PureComponent);
    var _super = (0,_create_super/* default */.Z)(GridImageWithParagraph);
    function GridImageWithParagraph() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, GridImageWithParagraph);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        grid_image_with_paragraph_define_property((0,_assert_this_initialized/* default */.Z)(_this), "handleClick", function() {
            var fullParagraph = _this.props.fullParagraph;
            var buttonConfig = fullParagraph.buttonConfig, title = fullParagraph.title;
            var ref = buttonConfig || {}, url = ref.url, buttonText = ref.buttonText;
            BigBrain("track", bigbrain_event_types.GRID_CARD_CLICKED, {
                kind: buttonText,
                info1: title,
                info2: url
            });
        });
        grid_image_with_paragraph_define_property((0,_assert_this_initialized/* default */.Z)(_this), "handleHover", function() {
            var fullParagraph = _this.props.fullParagraph;
            var buttonConfig = fullParagraph.buttonConfig, title = fullParagraph.title;
            var ref = buttonConfig || {}, url = ref.url, buttonText = ref.buttonText;
            BigBrain("track", bigbrain_event_types.GRID_CARD_HOVERED, {
                kind: buttonText,
                info1: title,
                info2: url
            });
        });
        grid_image_with_paragraph_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderParagraph", function() {
            var _props = _this.props, fullParagraph = _props.fullParagraph, titleSize = _props.titleSize, textSize = _props.textSize, width = _props.width, hideButton = _props.hideButton;
            var title = fullParagraph.title, body = fullParagraph.body, buttonConfig = fullParagraph.buttonConfig;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid-paragraph-wrapper",
                style: {
                    width: width
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "title-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(title_title/* default */.Z, {
                            title: title,
                            titleSize: titleSize
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "paragraph-body-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph/* default */.Z, {
                            body: body,
                            textSize: textSize
                        })
                    }),
                    !hideButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "button-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(secondary_button/* default */.Z, grid_image_with_paragraph_object_spread({}, buttonConfig))
                    })
                ]
            });
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(GridImageWithParagraph, [
        {
            key: "renderComponent",
            value: function renderComponent() {
                var _this_props = this.props, fullParagraph = _this_props.fullParagraph, titleSize = _this_props.titleSize, textSize = _this_props.textSize, restImageProps = _object_without_properties(_this_props, [
                    "fullParagraph",
                    "titleSize",
                    "textSize"
                ]);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid-image-with-paragraph",
                    children: [
                        (restImageProps === null || restImageProps === void 0 ? void 0 : restImageProps.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grid-image-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_image/* default */.Z, grid_image_with_paragraph_object_spread({}, restImageProps))
                        }),
                        this.renderParagraph()
                    ]
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var fullParagraph = this.props.fullParagraph;
                var buttonConfig = fullParagraph.buttonConfig;
                var ref = buttonConfig || {}, url = ref.url, isOpenLinkInNewTab = ref.isOpenLinkInNewTab;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGridImageWithParagraph, {
                    className: classnames_default()("card-grid-link", {
                        "without-link": !url
                    }),
                    href: url,
                    onClick: this.handleClick,
                    onMouseEnter: this.handleHover,
                    target: isOpenLinkInNewTab ? "_blank" : "_self",
                    children: this.renderComponent()
                });
            }
        }
    ]);
    return GridImageWithParagraph;
}(react.PureComponent);

GridImageWithParagraph.defaultProps = grid_image_with_paragraph_default_props;


/***/ }),

/***/ 80651:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    height: 300,
    width: 300,
    link: {}
});


/***/ }),

/***/ 94351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ GridImage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/picture-with-link/picture-with-link-component.js
var picture_with_link_component = __webpack_require__(94640);
// EXTERNAL MODULE: ./segments/desktop/core-components/images-grid/images-grid-service.js
var images_grid_service = __webpack_require__(72898);
// EXTERNAL MODULE: ./segments/desktop/core-components/grid-image/default-props.js
var default_props = __webpack_require__(80651);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-image/grid-image.scss.js

var StyledGridImage = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ezk0g6e0"
})("display:flex;.image{width:100%;}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-image/grid-image.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}






var GridImage = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(GridImage, PureComponent);
    var _super = (0,_create_super/* default */.Z)(GridImage);
    function GridImage() {
        (0,_class_call_check/* default */.Z)(this, GridImage);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(GridImage, [
        {
            key: "renderPicture",
            value: function renderPicture() {
                var _props = this.props, src = _props.src, alt = _props.alt, isDecorative = _props.isDecorative, link = _props.link, imageStyle = _props.imageStyle;
                var href = link.href, isNewTab = link.isNewTab;
                var target = isNewTab ? "_blank" : "_self";
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_with_link_component/* default */.Z, {
                    src: src,
                    alt: alt,
                    isDecorative: isDecorative,
                    className: "image",
                    target: target,
                    href: href,
                    specificImageStyle: imageStyle
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, height = _props.height, width = _props.width, imagePosition = _props.imagePosition;
                var imagePositionStyles = (0,images_grid_service/* getImagePositionStyles */.y)(imagePosition);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGridImage, {
                    className: "grid-image",
                    style: _object_spread({
                        height: height,
                        width: width
                    }, imagePositionStyles),
                    children: this.renderPicture()
                });
            }
        }
    ]);
    return GridImage;
}(react.PureComponent);

GridImage.defaultProps = default_props/* default */.Z;


/***/ }),

/***/ 32627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ grid_paragraph_with_image; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./segments/desktop/core-components/grid-image/grid-image.js + 1 modules
var grid_image = __webpack_require__(94351);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./services/bigbrain-service.js + 1 modules
var bigbrain_service = __webpack_require__(95470);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./segments/desktop/constants.js
var constants = __webpack_require__(73759);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-paragraph-with-image/grid-paragraph-with-image.scss.js




var StyledGridParagraphWithImage = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e17e2hrn0"
})("text-decoration:none;color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";height:100%;width:100%;display:flex;&.without-link{.grid-paragraph-with-image{cursor:initial;}}.grid-paragraph-with-image{display:flex;flex-direction:column;height:100%;width:100%;cursor:pointer;border-radius:18px;overflow:hidden;&.top{justify-content:flex-start;}&.center{justify-content:center;}&.bottom{justify-content:flex-end;}.tag{border-style:solid;border-width:2px;position:absolute;top:10px;right:10px;padding:3px 5px;}&:not(.without-shadow-hover):hover{", (0,constants.getComponentShadow)(), "}&.shadow{", (0,constants.getComponentShadow)(), "      &:not(.without-shadow-hover):hover{", (0,constants.getComponentShadowWithHoverEffect)(), "}}.grid-image-wrapper{.grid-image{.picture-component{display:flex;img{border-bottom-right-radius:16px;border-bottom-left-radius:16px;}}}}.grid-paragraph-wrapper{height:100%;padding:24px 24px 40px 24px;display:flex;flex-direction:column;.full-paragraph-topic-image-wrapper.left .picture-component > img{object-fit:contain;}.footer{display:flex;align-items:center;margin-top:10px;gap:10px;.footer-image{width:", function(param) {
    var footerImageWidth = param.footerImageWidth;
    return footerImageWidth !== null && footerImageWidth !== void 0 ? footerImageWidth : "auto";
}, ";height:auto;}}}}&.disabled-hover-effect{cursor:initial;.grid-paragraph-with-image{cursor:initial;&:hover{box-shadow:none;}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/grid-image/default-props.js
var default_props = __webpack_require__(80651);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/default-props.js
var title_default_props = __webpack_require__(51261);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/default-props.js
var paragraph_default_props = __webpack_require__(14066);
;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-paragraph-with-image/default-props.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var grid_paragraph_with_image_default_props = (_object_spread_props(_object_spread({}, default_props/* default */.Z), {
    showParagraph: true,
    fullParagraph: _object_spread({}, title_default_props/* default */.Z, paragraph_default_props/* default */.Z),
    cardColor: color_consts.WHITE_COLOR_NAME
}));

// EXTERNAL MODULE: ./utils/general.js
var general = __webpack_require__(56093);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./client/components/system/monday-markup-language/monday-markup-language-component.js + 11 modules
var monday_markup_language_component = __webpack_require__(36239);
;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-paragraph-with-image/grid-paragraph-with-image.js
function grid_paragraph_with_image_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function grid_paragraph_with_image_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            grid_paragraph_with_image_define_property(target, key, source[key]);
        });
    }
    return target;
}
function grid_paragraph_with_image_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function grid_paragraph_with_image_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        grid_paragraph_with_image_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}












var GridParagraphWithImage = function(props) {
    var borderColor = props.borderColor, showParagraph = props.showParagraph, fullParagraph = props.fullParagraph, titleSize = props.titleSize, textSize = props.textSize, cardTagText = props.cardTagText, contentVerticalAlignment = props.contentVerticalAlignment, paragraphVerticalColoredLineColor = props.paragraphVerticalColoredLineColor, padding = props.padding, backgroundImage = props.backgroundImage, cardColor = props.cardColor, borderOpacity = props.borderOpacity, cardWidthForCss = props.cardWidthForCss, disableHoverStyle = props.disableHoverStyle, footer = props.footer, imageOnTop = props.imageOnTop;
    var ref = (fullParagraph === null || fullParagraph === void 0 ? void 0 : fullParagraph.buttonConfig) || {}, url = ref.url, isOpenLinkInNewTab = ref.isOpenLinkInNewTab, buttonText = ref.buttonText;
    var handleClick = function() {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.FLEXIBLE_GRID_CARD_CLICKED, {
            kind: buttonText,
            info1: fullParagraph === null || fullParagraph === void 0 ? void 0 : fullParagraph.title,
            info2: url
        });
        url && window.open(url, isOpenLinkInNewTab ? "_blank" : "_self");
    };
    var getParagraphStyle = function() {
        return {
            padding: padding
        };
    };
    var getStyle = function() {
        var color = colors/* default */.Z[cardColor];
        var borderRgbaColor = borderColor === colors/* default.transparent */.Z.transparent ? borderColor : borderColor && (0,general/* hexToRgba */.a7)(colors/* default */.Z[borderColor], parseFloat(borderOpacity) || 1);
        var style = {
            backgroundColor: color,
            maxWidth: cardWidthForCss,
            border: "1px solid ".concat(borderRgbaColor)
        };
        if (backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.src) {
            style = grid_paragraph_with_image_object_spread_props(grid_paragraph_with_image_object_spread({}, style), {
                backgroundImage: "url(".concat(backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.src, ")"),
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: (backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.backgroundPosition) || "center"
            });
        }
        return style;
    };
    var renderParagraph = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: showParagraph && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("grid-paragraph-wrapper"),
                style: getParagraphStyle(),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, grid_paragraph_with_image_object_spread_props(grid_paragraph_with_image_object_spread({
                        titleSize: titleSize,
                        textSize: textSize
                    }, fullParagraph), {
                        paragraphVerticalColoredLineColor: paragraphVerticalColoredLineColor
                    })),
                    (footer === null || footer === void 0 ? void 0 : footer.showFooter) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "footer",
                        children: [
                            (footer === null || footer === void 0 ? void 0 : footer.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                className: "footer-image",
                                src: footer === null || footer === void 0 ? void 0 : footer.image
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                                className: "footer-text",
                                text: footer === null || footer === void 0 ? void 0 : footer.text
                            })
                        ]
                    })
                ]
            })
        });
    };
    var renderComponent = function() {
        var shadowCards = props.shadowCards, removeShadowOnHover = props.removeShadowOnHover, src = props.src, cardTagColor = props.cardTagColor, restImageProps = _object_without_properties(props, [
            "shadowCards",
            "removeShadowOnHover",
            "src",
            "cardTagColor"
        ]);
        var tagColor = colors/* default */.Z[cardTagColor];
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("grid-paragraph-with-image", {
                shadow: shadowCards,
                "without-shadow-hover": removeShadowOnHover
            }, contentVerticalAlignment),
            style: getStyle(),
            children: [
                cardTagText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tag",
                    style: {
                        borderColor: tagColor,
                        color: tagColor
                    },
                    children: cardTagText
                }),
                imageOnTop && src && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid-image-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_image/* default */.Z, grid_paragraph_with_image_object_spread({
                        src: src
                    }, restImageProps))
                }),
                renderParagraph(),
                !imageOnTop && src && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid-image-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_image/* default */.Z, grid_paragraph_with_image_object_spread({
                        src: src
                    }, restImageProps))
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGridParagraphWithImage, {
        className: classnames_default()("card-grid-link", {
            "without-link": !url,
            "disabled-hover-effect": disableHoverStyle
        }),
        onClick: handleClick,
        rel: "noreferrer",
        footerImageWidth: footer === null || footer === void 0 ? void 0 : footer.imageWidth,
        children: renderComponent()
    });
};
GridParagraphWithImage.defaultProps = grid_paragraph_with_image_object_spread({}, grid_paragraph_with_image_default_props);
/* harmony default export */ var grid_paragraph_with_image = (GridParagraphWithImage);


/***/ }),

/***/ 38885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ flexible_cards_grid_component; }
});

// EXTERNAL MODULE: ./components/enhancements/responsive-hoc/responsive-hoc-component.js + 1 modules
var responsive_hoc_component = __webpack_require__(27190);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/core-components/grid-paragraph-with-image/grid-paragraph-with-image.js + 2 modules
var grid_paragraph_with_image = __webpack_require__(32627);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/components/basic-header/constants.js
var constants = __webpack_require__(72428);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/flexible-cards-grid/components/flexible-cards-grid-desktop/flexible-cards-grid-desktop-component.scss.js



var StyledFlexibleCardsGridDesktopComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "evb99rm0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;height:100%;margin:auto;display:flex;flex-wrap:wrap;justify-content:var(--component-alignment);.flexible-cards-grid-desktop-component-inner{display:flex;justify-content:inherit;.grid-paragraph-with-image-component-wrapper{width:var(--flexible-grid-card-width);margin:var(--cards-margin);z-index:", z_index/* TOP_LAYER */.nA, ";position:relative;display:flex;.top-layer{width:100%;}&.has-background-paragraph{.top-layer{opacity:1;transition:opacity 0.25s ease-in-out;}.back-layer{position:absolute;opacity:0;height:100%;width:100%;transition:opacity 0.25s ease-in-out;}&:hover{.top-layer{opacity:0;}.back-layer{opacity:1;}}}.grid-paragraph-wrapper{display:flex;.full-paragraph{height:100%;}}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/grid-image-with-paragraph/grid-image-with-paragraph.js + 2 modules
var grid_image_with_paragraph = __webpack_require__(47755);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/flexible-cards-grid/components/default-props.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


var getGridImageWithParagraphProps = function(imageSrc, fullParagraphTitle, fullParagraphBody) {
    var fullParagraph = _object_spread_props(_object_spread({}, grid_image_with_paragraph/* default.defaultProps.fullParagraph */.Z.defaultProps.fullParagraph), {
        title: fullParagraphTitle,
        body: fullParagraphBody
    });
    return _object_spread_props(_object_spread({}, grid_image_with_paragraph/* default.defaultProps */.Z.defaultProps), {
        src: imageSrc,
        mobileImage: {
            src: imageSrc
        },
        fullParagraph: fullParagraph,
        cardNumOfColumnsWidth: 1
    });
};
/* harmony default export */ var default_props = ({
    shadowCards: true,
    removeShadowOnHover: false,
    gridAlignment: "center",
    gridItems: [
        getGridImageWithParagraphProps("https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Grid/small-placeholder-image.png", "Cross-functional collab blog", "Look at your data differently with multiple View options from Calendar to Map."),
        getGridImageWithParagraphProps("https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Grid/small-placeholder-image.png", "Relevant story/video", "Automate repetitive tasks and have more time for the work that motivates you."),
        getGridImageWithParagraphProps("https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Grid/small-placeholder-image.png", "Productivity blog or marketing blog", "Get a high-level overview at a glance and make smarter decisions, faster."),
        getGridImageWithParagraphProps("https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Grid/small-placeholder-image.png", "Productivity blog or marketing blog", "Get a high-level overview at a glance and make smarter decisions, faster.")
    ],
    paddingTop: "64px",
    paddingBottom: "64px",
    titleSize: sizes.XS,
    textSize: sizes.MD
});

// EXTERNAL MODULE: ./segments/desktop/grid/layouts/flexible-cards-grid/flexible-cards-consts.js
var flexible_cards_consts = __webpack_require__(71021);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./services/bigbrain-service.js + 1 modules
var bigbrain_service = __webpack_require__(95470);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/flexible-cards-grid/components/flexible-cards-grid-desktop/flexible-cards-grid-desktop-component.js
function flexible_cards_grid_desktop_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function flexible_cards_grid_desktop_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            flexible_cards_grid_desktop_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function flexible_cards_grid_desktop_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function flexible_cards_grid_desktop_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        flexible_cards_grid_desktop_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}










var IMAGE_HEIGHT = "100%";
var IMAGE_WIDTH = "100%";
var margin = "".concat(flexible_cards_consts/* MARGIN_BETWEEN_CARDS */.K / 2, "px");
var FlexibleCardsGridDesktopComponent = function(props) {
    var renderGridItems = function() {
        var shadowCards = props.shadowCards, removeShadowOnHover = props.removeShadowOnHover, gridItems = props.gridItems, titleSize = props.titleSize, textSize = props.textSize, topicBottomMargin = props.topicBottomMargin, spaceFromParagraph = props.spaceFromParagraph, buttonTopMargin = props.buttonTopMargin, innerPadding = props.innerPadding, defaultCardClick = props.defaultCardClick, borderColor = props.borderColor;
        return gridItems.map(function(gridItem, index) {
            var textColor = gridItem.textColor, cardColor = gridItem.cardColor, backgroundImage = gridItem.backgroundImage, cardNumOfColumnsWidth = gridItem.cardNumOfColumnsWidth, fullParagraph = gridItem.fullParagraph, addBackLayerContent = gridItem.addBackLayerContent, cardBackLayerContent = gridItem.cardBackLayerContent, cardTagText = gridItem.cardTagText, cardTagColor = gridItem.cardTagColor, paragraphVerticalColoredLineColor = gridItem.paragraphVerticalColoredLineColor, onCardClick = gridItem.onCardClick, resImageProps = _object_without_properties(gridItem, [
                "textColor",
                "cardColor",
                "backgroundImage",
                "cardNumOfColumnsWidth",
                "fullParagraph",
                "addBackLayerContent",
                "cardBackLayerContent",
                "cardTagText",
                "cardTagColor",
                "paragraphVerticalColoredLineColor",
                "onCardClick"
            ]);
            var flexibleCardHovered = function() {
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.FLEXIBLE_GRID_CARD_HOVERED, {
                    kind: (fullParagraph === null || fullParagraph === void 0 ? void 0 : fullParagraph.title) || (fullParagraph === null || fullParagraph === void 0 ? void 0 : fullParagraph.body)
                });
            };
            var columnWidthForCss = "".concat(flexible_cards_consts/* COLUMN_WIDTH */.p, "px");
            var cardWidthForCss;
            if (cardNumOfColumnsWidth) {
                var cardWidth = cardNumOfColumnsWidth * flexible_cards_consts/* COLUMN_WIDTH */.p + (cardNumOfColumnsWidth - 1) * flexible_cards_consts/* MARGIN_BETWEEN_CARDS */.K;
                cardWidthForCss = "".concat(cardWidth, "px");
            }
            var onClickCallBack = onCardClick || defaultCardClick;
            var isCardClickable = onClickCallBack;
            var onKeyDown = isCardClickable ? (0,accessibility_service/* generateOnKeyDownHandler */.vR)(onClickCallBack) : null;
            var cardAccesibilityProps = isCardClickable ? {
                onKeyDown: onKeyDown,
                tabIndex: 0
            } : {};
            var layersSharedProps = {
                topicBottomMargin: topicBottomMargin,
                spaceFromParagraph: spaceFromParagraph,
                buttonTopMargin: buttonTopMargin
            };
            var fullParagraphFullProps = flexible_cards_grid_desktop_component_object_spread({}, layersSharedProps, fullParagraph);
            var backLayerparagraphProps = flexible_cards_grid_desktop_component_object_spread({}, layersSharedProps, cardBackLayerContent === null || cardBackLayerContent === void 0 ? void 0 : cardBackLayerContent.backLayerFullParagraph);
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", flexible_cards_grid_desktop_component_object_spread_props(flexible_cards_grid_desktop_component_object_spread({
                className: classnames_default()("grid-paragraph-with-image-component-wrapper", {
                    "has-background-paragraph": addBackLayerContent
                }),
                style: {
                    "--flexible-grid-card-width": cardWidthForCss || columnWidthForCss,
                    "--cards-margin": margin
                },
                onClick: onClickCallBack
            }, cardAccesibilityProps), {
                role: "listitem",
                onMouseEnter: flexibleCardHovered,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "top-layer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_paragraph_with_image/* default */.Z, flexible_cards_grid_desktop_component_object_spread_props(flexible_cards_grid_desktop_component_object_spread({}, resImageProps), {
                            borderColor: borderColor,
                            fullParagraph: fullParagraphFullProps,
                            width: IMAGE_WIDTH,
                            height: IMAGE_HEIGHT,
                            titleSize: titleSize,
                            textSize: textSize,
                            cardColor: cardColor,
                            textColor: textColor,
                            shadowCards: shadowCards,
                            removeShadowOnHover: removeShadowOnHover,
                            cardWidthForCss: cardWidthForCss,
                            backgroundImage: backgroundImage,
                            cardTagText: cardTagText,
                            cardTagColor: cardTagColor,
                            paragraphVerticalColoredLineColor: paragraphVerticalColoredLineColor,
                            padding: innerPadding
                        }))
                    }),
                    addBackLayerContent && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "back-layer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_paragraph_with_image/* default */.Z, {
                            fullParagraph: backLayerparagraphProps,
                            width: IMAGE_WIDTH,
                            height: IMAGE_HEIGHT,
                            titleSize: titleSize,
                            textSize: textSize,
                            cardColor: cardColor,
                            textColor: textColor,
                            shadowCards: shadowCards,
                            borderColor: borderColor,
                            removeShadowOnHover: removeShadowOnHover,
                            cardWidthForCss: cardWidthForCss,
                            contentVerticalAlignment: cardBackLayerContent === null || cardBackLayerContent === void 0 ? void 0 : cardBackLayerContent.contentVerticalAlignment,
                            padding: innerPadding,
                            backgroundImage: cardBackLayerContent === null || cardBackLayerContent === void 0 ? void 0 : cardBackLayerContent.backSideBackgroundImage
                        })
                    })
                ]
            }), index);
        });
    };
    var gridAlignment = props.gridAlignment;
    var componentWidthWithoutHeaderPadding = "calc(100% - ".concat(constants/* default.HEADER_CONTENT_HORIZONTAL_PADDING */.Z.HEADER_CONTENT_HORIZONTAL_PADDING * 2 - flexible_cards_consts/* MARGIN_BETWEEN_CARDS */.K, "px)");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFlexibleCardsGridDesktopComponent, {
        className: "flexible-cards-grid-desktop-component",
        style: {
            "--component-alignment": gridAlignment
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flexible-cards-grid-desktop-component-inner",
            style: {
                width: componentWidthWithoutHeaderPadding
            },
            role: "list",
            children: renderGridItems()
        })
    });
};
FlexibleCardsGridDesktopComponent.defaultProps = default_props;
/* harmony default export */ var flexible_cards_grid_desktop_component = (FlexibleCardsGridDesktopComponent);

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/carousel.js + 3 modules
var carousel = __webpack_require__(28391);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/flexible-cards-grid/components/flexible-cards-grid-mobile/flexible-cards-grid-mobile-component.scss.js
var componentStyles = new String(".flexible-cards-grid-mobile-component{.carousel-wrapper{margin-top:30px;width:auto;&.no-margin{margin-top:0px}.carousel{.slick-slider{.slick-dots{bottom:0px}}.grid-paragraph-with-image-component-wrapper{overflow:hidden;-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px;padding:25px 20px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;width:100%;.grid-paragraph-with-image{.grid-paragraph-wrapper{padding-right:20px;padding-left:20px;.full-paragraph{.full-paragraph-topic{font-size:.6875rem;margin-bottom:8px}.title-wrapper{font-size:.875rem;margin-bottom:10px}.paragraph-body-wrapper{.paragraph-wrapper .paragraph-body{font-size:.8125rem;line-height:24px}}}}}}}}}");
componentStyles.__hash = "f0260ba55678d501";

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/flexible-cards-grid/components/flexible-cards-grid-mobile/flexible-cards-grid-mobile-component.js
function flexible_cards_grid_mobile_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function flexible_cards_grid_mobile_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            flexible_cards_grid_mobile_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function flexible_cards_grid_mobile_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function flexible_cards_grid_mobile_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        flexible_cards_grid_mobile_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var FlexibleCardsGridMobileComponent = function(props) {
    var gridItems = props.gridItems, titleSize = props.titleSize, textSize = props.textSize, shadowCards = props.shadowCards, removeShadowOnHover = props.removeShadowOnHover, cancelMobileMarginTop = props.cancelMobileMarginTop, _mobileCenterPadding = props.mobileCenterPadding, mobileCenterPadding = _mobileCenterPadding === void 0 ? "10%" : _mobileCenterPadding;
    var itemRenderer = function(gridItem) {
        var mobileImage = gridItem.mobileImage, textColor = gridItem.textColor, cardColor = gridItem.cardColor, fullParagraph = gridItem.fullParagraph, footer = gridItem.footer;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "grid-paragraph-with-image-component-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_paragraph_with_image/* default */.Z, flexible_cards_grid_mobile_component_object_spread_props(flexible_cards_grid_mobile_component_object_spread({}, mobileImage), {
                fullParagraph: fullParagraph,
                width: "100%",
                height: "auto",
                titleSize: titleSize,
                textSize: textSize,
                cardColor: cardColor,
                textColor: textColor,
                shadowCards: shadowCards,
                removeShadowOnHover: removeShadowOnHover,
                footer: footer
            }))
        });
    };
    var carouselProps = {
        items: gridItems,
        itemRenderer: itemRenderer,
        defaultIndex: 0,
        infinite: false,
        slidesToShow: 1,
        dots: true,
        centerPadding: mobileCenterPadding,
        focusAfterSwipe: true
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-".concat(componentStyles.__hash) + " " + "flexible-cards-grid-mobile-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "jsx-".concat(componentStyles.__hash) + " " + (classnames_default()("carousel-wrapper", {
                    "no-margin": cancelMobileMarginTop
                }) || ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* default */.Z, flexible_cards_grid_mobile_component_object_spread({}, carouselProps))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                id: componentStyles.__hash,
                children: componentStyles
            })
        ]
    });
};
/* harmony default export */ var flexible_cards_grid_mobile_component = (FlexibleCardsGridMobileComponent);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/flexible-cards-grid/flexible-cards-grid-component.js




var FlexibleCardGridComponent = (0,responsive_hoc_component/* default */.Z)(flexible_cards_grid_desktop_component, flexible_cards_grid_mobile_component);
/* harmony default export */ var flexible_cards_grid_component = (FlexibleCardGridComponent);
FlexibleCardGridComponent.defaultProps = default_props;


/***/ })

}]);